import { useState } from "react";

const depoimentos = [
  {
    id: 1,
    nome: "Mariana Oliveira",
    local: "São Paulo, SP — Apartamento 85m²",
    texto: "Fiquei impressionada com a transformação! O piso chegou rápido, a instalação foi feita em um dia e o resultado ficou incrível. Parece que meu apartamento dobrou de valor. Recomendo demais a Vynora!",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20smiling%20Brazilian%20woman%20in%20her%2030s%2C%20warm%20natural%20light%2C%20clean%20background%2C%20realistic%20portrait%20photography&width=120&height=120&seq=av001&orientation=squarish",
    estrelas: 5,
  },
  {
    id: 2,
    nome: "Carlos Eduardo Santos",
    local: "Campinas, SP — Casa 120m²",
    texto: "Melhor custo-benefício que encontrei. Direto da fábrica mesmo, sem enrolação. O piso é de altíssima qualidade, resistente e com visual de madeira nobre. Toda a casa ficou com cara de revista.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20smiling%20Brazilian%20man%20in%20his%2040s%2C%20warm%20natural%20light%2C%20clean%20background%2C%20realistic%20portrait%20photography&width=120&height=120&seq=av002&orientation=squarish",
    estrelas: 5,
  },
  {
    id: 3,
    nome: "Fernanda Costa",
    local: "Rio de Janeiro, RJ — Apartamento 70m²",
    texto: "Sempre tive medo de reforma, mas a Vynora mudou tudo isso. Sem poeira, sem barulho excessivo, sem estresse. Em dois dias meu apartamento estava completamente transformado. Simplesmente perfeito!",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20smiling%20Brazilian%20woman%20in%20her%20late%2020s%2C%20warm%20natural%20light%2C%20clean%20background%2C%20realistic%20portrait%20photography&width=120&height=120&seq=av003&orientation=squarish",
    estrelas: 5,
  },
  {
    id: 4,
    nome: "Roberto Almeida",
    local: "Belo Horizonte, MG — Cobertura 150m²",
    texto: "Atendimento impecável do início ao fim. A equipe foi super profissional, pontual e cuidadosa. O piso ficou perfeito, uniforme, sem nenhuma imperfeição. Já indiquei para vários amigos!",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20smiling%20Brazilian%20man%20in%20his%2050s%2C%20warm%20natural%20light%2C%20clean%20background%2C%20realistic%20portrait%20photography&width=120&height=120&seq=av004&orientation=squarish",
    estrelas: 5,
  },
  {
    id: 5,
    nome: "Juliana Mendes",
    local: "Curitiba, PR — Apartamento 95m²",
    texto: "Comprei o piso com um pouco de receio por ser online, mas foi a melhor decisão. Qualidade surpreendente, preço justo e entrega no prazo. Meu apartamento ficou com um visual de alto padrão!",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20smiling%20Brazilian%20woman%20in%20her%2035s%2C%20warm%20natural%20light%2C%20clean%20background%2C%20realistic%20portrait%20photography&width=120&height=120&seq=av005&orientation=squarish",
    estrelas: 5,
  },
];

export default function ProvasSocial() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? depoimentos.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === depoimentos.length - 1 ? 0 : c + 1));

  const dep = depoimentos[current];

  return (
    <section id="depoimentos" className="py-14 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block text-amber-700 text-xs font-bold tracking-widest uppercase mb-3">Clientes Satisfeitos</span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-stone-800 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            O que nossos clientes dizem
          </h2>
          <p className="text-stone-500 text-sm md:text-lg">Transformações reais, satisfação garantida</p>
          <div className="w-12 h-0.5 bg-amber-600 mx-auto mt-5" />
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-6 mb-10 md:mb-16">
          {[
            { num: "500+", label: "Ambientes transformados" },
            { num: "98%", label: "Clientes satisfeitos" },
            { num: "4+", label: "Anos de experiência" },
          ].map((stat) => (
            <div key={stat.label} className="text-center bg-white rounded-xl md:rounded-2xl p-4 md:p-6 border border-stone-100">
              <p className="text-2xl md:text-4xl font-bold text-amber-700 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.num}</p>
              <p className="text-stone-500 text-xs md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Testimonial Carousel */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-12 border border-stone-100 relative">
            {/* Quote icon */}
            <div className="w-10 h-10 flex items-center justify-center mb-4">
              <i className="ri-double-quotes-l text-4xl text-amber-200" />
            </div>

            {/* Stars */}
            <div className="flex gap-1 mb-4">
              {Array.from({ length: dep.estrelas }).map((_, i) => (
                <div key={i} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-500 text-base" />
                </div>
              ))}
            </div>

            {/* Text */}
            <p className="text-stone-700 text-base md:text-xl leading-relaxed mb-6 italic" style={{ fontFamily: "'Playfair Display', serif" }}>
              &ldquo;{dep.texto}&rdquo;
            </p>

            {/* Author */}
            <div>
              <p className="font-bold text-stone-800 text-sm md:text-base">{dep.nome}</p>
              <p className="text-stone-400 text-xs">{dep.local}</p>
            </div>

            {/* Navigation */}
            <div className="flex gap-3 mt-5 md:mt-0 md:absolute md:bottom-8 md:right-8">
              <button
                onClick={prev}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-200 hover:border-amber-600 hover:text-amber-700 text-stone-600 transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-line text-sm" />
              </button>
              <button
                onClick={next}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-amber-700 hover:bg-amber-600 text-white transition-all cursor-pointer"
              >
                <i className="ri-arrow-right-line text-sm" />
              </button>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-5">
            {depoimentos.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`rounded-full transition-all cursor-pointer ${i === current ? "w-5 h-2 bg-amber-700" : "w-2 h-2 bg-stone-300"}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
